// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__15XBZ","content":"styles_content__2coW2","checkbox":"styles_checkbox__aruhe","checkboxLabel":"styles_checkboxLabel__1kP7q"};